export class VacationReport {
  fromDate: Date
  toDate: Date
  leaveTypeId: number = 0
  teamLeadId: number
  statusId: number = 0
  userIds: number[] = []
}
